// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__2EZy6","content":"Dashboard_content__Oq7Xp","section":"Dashboard_section__3yRq6","centerContainer":"Dashboard_centerContainer__sIAoR"};